import styled, { css } from "styled-components";
import { Button, Card, Flex } from "discover.medical.react-component-library";

export const CardContainer = styled(Card)`
  flex-direction: row;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }
`;

export const CardContent = styled(Flex)`
  order: 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    order: 1;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    order: 0;
  }
`;

export const Image = styled.div`
  background-size: cover;
  width: 33.3%;
  flex: none;
  background-image: ${({ portraitSrc }) => css`url(${portraitSrc})`};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    background-image: ${({ landscapeSrc }) => css`url(${landscapeSrc})`};
    width: 100%;
    height: 7.25rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    background-image: ${({ portraitSrc }) => css`url(${portraitSrc})`};
    width: 33.3%;
    display: block;
    height: auto;
  }
`;

export const BaseIconImage = styled.div`
  background-image: ${({ iconSrc }) => css`url(${iconSrc})`};
  background-size: cover;
  align-self: center;
  flex: none;
`;

export const IconImage = styled(BaseIconImage)`
  width: 7.25rem;
  height: 7.25rem;
  margin-right: ${({ theme }) => theme.space.md};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;

export const SmallIconImage = styled(BaseIconImage)`
  display: none;
  width: ${({ theme }) => theme.space.xl};
  height: ${({ theme }) => theme.space.xl};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const NavButton = styled(Button)`
  margin-top: ${({ theme }) => theme.space.md};
`;

export const StyledDescriptionContent = styled.span`
  & sup {
    font-size: ${(props) => props.theme.font.size.xs};
    vertical-align: super;
  }
`;
